import React, {useEffect, useState} from 'react';
import {Col, Divider, Row, Table} from "antd";
import {EyeOutlined} from "@ant-design/icons";
import {callService, processClick} from "../utils/allinteraction";

export default function SummaryTable({mainData, results, firstRowDivHeight, pdb, onNestedRowClick}) {

    const [dataSmall, setDataSmall] = useState([]);
    const [dataFull, setDataFull] = useState([]);

    //Res. Name 1,Res. Number 1,Chain 1,Complex ASA,Free ASA,Buried ASA (Interface),Buried ASA %
    const summaryColumnsSmall = [{title: 'Residue interactions', dataIndex: 1, key: 0},
        {title: 'Value', dataIndex: 2, key: 1, sorter: (a, b) => a[2] - b[2], defaultSortOrder: "descend"}];

    const summaryColumnsFull = [{title: 'Atomic interactions', dataIndex: 1, key: 0},
        {title: 'Value', dataIndex: 2, key: 1, align: "center", sorter: (a, b) => a[2] - b[2], defaultSortOrder: "descend"},
        {
            title: 'Show all in Mol*', render: (_, record) => (
                <EyeOutlined
                    style={{fontSize: "18px", color: "#1890ff", cursor: "pointer"}}
                    onClick={() => handleClick(record)}
                />
            ),
            width: 150,
            align: "center"
        }];

    const handleClick = (record) => {
        const interactionType = record[1].slice(10, -1);

        processClick(interactionType, results).then((data) => {
            data.forEach(row => onNestedRowClick(row, interactionType, false));
            document.getElementById("molstar").scrollIntoView({behavior: 'smooth'});
        });
    };

    useEffect(() => {

        const postDataSmall = new FormData();
        postDataSmall.append("tableName", "small_summary");
        postDataSmall.append("folder", results.dataFolder);
        postDataSmall.append("pdb", results.pdb);
        postDataSmall.append("chain1", results.chain1);
        postDataSmall.append("chain2", results.chain2);

        callService(postDataSmall, 'get_table.php').then((data) => setDataSmall(data));

        const postDataFull = new FormData();
        postDataFull.append("tableName", "summary_table");
        postDataFull.append("folder", results.dataFolder);
        postDataFull.append("pdb", results.pdb);
        postDataFull.append("chain1", results.chain1);
        postDataFull.append("chain2", results.chain2);

        callService(postDataFull, 'get_table.php').then((data) => setDataFull(data));


    }, [mainData])

    return (
        <>
            <Row>
                <Col span={24}>
                    <Divider style={{fontSize: '24px'}}>Summary of interactions</Divider>
                </Col>
            </Row>
            <Row>
                <Col span={12} align="middle">
                    <div style={{padding: '10px'}} className={"main-table-container"}>
                        <Table size={"small"} rowKey={0} dataSource={dataFull} columns={summaryColumnsFull} pagination={false} scroll={{y: firstRowDivHeight - 100}}/>
                    </div>
                </Col>
                <Col span={12}>
                    <div style={{padding: '10px'}}>
                        <Table size={"small"} rowKey={0} dataSource={dataSmall} columns={summaryColumnsSmall} pagination={false}/>
                    </div>
                </Col>
            </Row>
        </>
    )
}